import React, {useRef, useState, useEffect} from "react";
import {Swiper, SwiperSlide} from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import {Autoplay, Pagination, Navigation} from "swiper";
import './Slider.scss';
import {fileManager} from '../Constants';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

export default function Slider(Props) {
    // const [sliderData, setSliderData] = useState([]);
    // useEffect(() => {
    //     let MenuFromLocalStorage = localStorage.getItem('dataFromLocalStorage');
    //     if (MenuFromLocalStorage) {
    //         const Sliders = localStorage.getItem('Sliders');
    //         setSliderData(JSON.parse(Sliders));
    //     } else {
    //         axiosServise.get(`Sliders`).then(response => {
    //             const responseApi = response.data.content;
    //             setSliderData(responseApi)
    //             localStorage.setItem("Sliders", JSON.stringify(responseApi));
    //         })
    //     }
    // }, []);


    return (
        <div className="carousel-container2 mySwiper bg-info">
            <Swiper
                spaceBetween={30}
                centeredSlides={true}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}
                pagination={{
                    clickable: true,
                }}
                navigation={true}
                modules={[Autoplay, Pagination, Navigation]}
                className="SliderSwiper">
                {Props.sliderData.map((item, index) => {
                    return (
                        <SwiperSlide key={index} title={item.title} onClick={item.sliderBase64}>
                            <Row className='g-0'>
                                <Col>
                                    <div className='imgSize' style={{height: Props.ImageHeight}}>
                                        <img className='stretch' src={`${fileManager}${item?.pictureId}`} alt=""/>
                                    </div>
                                </Col>
                            </Row>
                            <Row className='g-0'>
                                <Col>
                                    <div className="carousel-shadow2">

                                        <span >{item.title}</span>
                                    </div>
                                </Col>
                            </Row>
                        </SwiperSlide>

                    )
                })}
            </Swiper>


        </div>

    )
}
